export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export type AuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: null | AppUser;
};

export type JWTContextType = {
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
};

export const clientRoles = {
  unauthorized: 'unauthorized',
  withoutCompanies: 'withoutCompanies',
  superAdmin: 'Super admin',
  accountAdmin: 'Account admin',
  companyOwner: 'Company owner',
  fleetManager: 'Fleet manager',
  driver: 'Driver',
  accounting: 'Accounting',
  techSupport: 'Tech Support',
  emdAdmin: 'EMD admin',
  multi_owner: 'Multi company owner',
} as const;

export type ClientKeys = keyof typeof clientRoles;
export type UserRole = (typeof clientRoles)[ClientKeys];

export interface AppUser {
  role_name: UserRole;
  email: string;
  id?: number;
  phone?: string;
  name?: string;
  surname?: string;
  username?: string;
  password?: string;
  address?: string;
  company_name?: string;
  license_state?: string;
  id_number?: string;
  dl_number?: string;
  fleetlive_organization_id?: string;
}
